import { css } from 'lit';

var css_248z = css``;

export { css_248z as default };
//# sourceMappingURL=sgds-radio-group2.js.map
